module.exports = __webpack_public_path__ + "static/media/Salary70k.96e0b578.png";